import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { environment } from '@env/environment';

@Component({
  selector: 'app-compatibility-info-dialog',
  templateUrl: './compatibility-info-dialog.component.html',
  styleUrls: ['./compatibility-info-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CompatibilityInfoDialogComponent implements OnInit {
  constructor(private matSnackBarRef: MatSnackBarRef<CompatibilityInfoDialogComponent>) {}

  public company = environment.tenant.trim().toLowerCase();

  ngOnInit() {
    sessionStorage.setItem('compatibilityWindow', 'shown');
  }

  close() {
    this.matSnackBarRef.dismiss();
  }
}
